import { innerPage, routeWith, siteModule } from "./constants";

export const banner = {
    about: {
        background: "assets/images/banner/about.png",
        title: "About Us",
        crumb: "About Us",
        watermark: "Maven Merge"
    },
    faq: {
        background: "assets/images/banner/faq.png",
        title: "Faq Page",
        crumb: "Faq Page",
        watermark: "Maven Merge"
    },
    gallery: {
        background: "assets/images/banner/gallery.jpg",
        title: "Gallery Page",
        crumb: "Gallery Page",
        watermark: "It Solution"
    },
    icons: {
        background: "assets/images/banner/bnr-4.jpg",
        title: "Icons",
        crumb: "icon-font",
        watermark: "It Solution"
    },
    testimonials: {
        background: "assets/images/banner/testo.jpg",
        title: "Testimonials",
        crumb: "Testimonials",
        watermark: "It Solution"
    },
    whychooseus: {
        background: "assets/images/banner/bnr-8.jpg",
        title: "Why choose Us",
        crumb: "Why choose Us",
        watermark: "It Solution"
    },
    pricing: {
        background: "assets/images/banner/plan.jpg",
        title: "Price Table",
        crumb: "Price Table",
        watermark: "It Solution"
    },
    plandetail: {
        background: "assets/images/banner/plan.jpg",
        title: "Plan Details",
        crumb: "Plan Details",
        watermark: "Maven Merge"
    },
    team: {
        background: "assets/images/banner/bnr-2.jpg",
        title: "Team Member",
        crumb: "Our Team",
        watermark: "It Solution"
    },
    mission: {
        background: "assets/images/banner/mission.jpg",
        title: "Mission & Vision",
        crumb: "Mission & Vision",
        watermark: "It Solution"
    },
    services: {
        background: "assets/images/banner/ourServices.jpg",
        title: "Our Services",
        crumb: "Our Services",
        watermark: "It Solution"
    },
    portfolio1: {
        background: "assets/images/banner/products.jpg",
        title: "Portfolio Page",
        crumb: "Portfolio",
        watermark: "It Solution"
    },
    portfolio2: {
        background: "assets/images/banner/bnr-5.jpg",
        title: "Portfolio-2 Page",
        crumb: "Portfolio-2 Page",
        watermark: "It Solution"
    },
    portfoliodetail: {
        background: "assets/images/banner/bnr-7.jpg",
        title: "Portfolio Detail",
        crumb: "Portfolio Detail",
        watermark: "It Solution"
    },
    bloggrid: {
        background: "assets/images/banner/blog.jpg",
        title: "Blog Page",
        crumb: "Blog Page",
        watermark: "It Solution"
    },
    bloglist: {
        background: "assets/images/banner/bnr-8.jpg",
        title: "Blog Arcive",
        crumb: "Blog Single Grid",
        watermark: "It Solution"
    },
    blogdetailsidebar: {
        background: "assets/images/banner/bnr-10.jpg",
        title: "Blog Detail",
        crumb: "Blog Detail",
        watermark: "It Solution"
    },
    blogdetail: {
        background: "assets/images/banner/blog-details.jpg",
        title: "Blog Detail",
        crumb: "Blog Detail",
        watermark: "It Solution"
    },
    contact: {
        background: "assets/images/banner/ContactUsBanner.png",
        title: "Contact Us",
        crumb: "Contact Us",
        watermark: "It Solution"
    },
    offers: {
        background: "assets/images/banner/offer.jpg",
        title: "Offers & Deals",
        crumb: "Offers",
        watermark: "Maven Merge"
    },
    careers: {
        background: "assets/images/banner/jobs.jpg",
        title: "Careers",
        crumb: "Careers",
        watermark: "Maven Merge"
    }
}

export function setBannerData(_url: string): {} {
    // Match on the path only — ignore query string (?plan=...) and fragments,
    // so banners still resolve on routes that carry params.
    const path = _url.split('?')[0].split('#')[0];
    switch (path) {
        case routeWith(siteModule.COMPANY, innerPage.ABOUT):
            return banner.about;
        case routeWith(siteModule.COMPANY, innerPage.FAQ):
            return banner.faq;
        case routeWith(siteModule.COMPANY, innerPage.GALLERY):
            return banner.gallery;
        case routeWith(siteModule.COMPANY, innerPage.ICONS):
            return banner.icons;
        case routeWith(siteModule.COMPANY, innerPage.TESTIMONIALS):
            return banner.testimonials;
        case routeWith(siteModule.COMPANY, innerPage.WHYCHOOSEUS):
            return banner.whychooseus;
        case routeWith(siteModule.COMPANY, innerPage.PRICING):
            return banner.pricing;
        case routeWith(siteModule.COMPANY, innerPage.TEAM):
            return banner.team;
        case routeWith(siteModule.ITSOLUTIONS, innerPage.MISSION):
            return banner.mission;
        case routeWith(siteModule.ITSOLUTIONS, innerPage.SERVICES):
            return banner.services;
        case routeWith(siteModule.ITSOLUTIONS, innerPage.PORTFOLIO1):
            return banner.portfolio1;
        case routeWith(siteModule.ITSOLUTIONS, innerPage.PORTFOLIO2):
            return banner.portfolio2;
        // PORTFOLIO_DETAIL has its own custom hero (mm-pd-hero) — no theme banner (avoids double banner).
        case routeWith(siteModule.ITBLOGS, innerPage.BLOGS_GRID):
            return banner.bloggrid;
        case routeWith(siteModule.ITBLOGS, innerPage.BLOGS_LIST_SIDEBAR):
            return banner.bloglist;
        case routeWith(siteModule.ITBLOGS, innerPage.BLOGS_DETAIL_SIDEBAR):
            return banner.blogdetailsidebar;
        // BLOGS_DETAIL has its own custom hero (mm-bd-hero) — no theme banner (avoids double banner).
        case routeWith(siteModule.COMPANY, innerPage.CONTACT):
            return banner.contact;
        case routeWith(siteModule.COMPANY, innerPage.OFFERS):
            return banner.offers;
        case routeWith(siteModule.COMPANY, innerPage.CAREERS):
            return banner.careers;
        default:
            return {};
    }
}
